goog.provide("shadow.js.shim.module$$mui$material$Select$default");
shadow.js.shim.module$$mui$material$Select$default = shadow.js.shim.module$$mui$material$Select.default;
